interface Props {
  title: string;
  count: number;
  description: string;
  imageSrc: string;
}

const DashboardItem = ({ title, count, description, imageSrc }: Props) => (
  <div className="flex-1 bg-white p-5 m-auto rounded-xl shadow-md flex flex-col items-center text-center mt-6 aspect-w-1 aspect-h-1 w-full">
    <img
      src={imageSrc}
      alt={`${title} icon`}
      className="aspect-w-1 aspect-h-1 h-8 w-8"
    />
    <p className="text-gray-600 mt-2">{description}</p>
    <p className="text-4xl font-bold text-[#4BBFED] mt-2">{count}</p>
  </div>
);

export default DashboardItem;
